export const en = {
  'nav.clientHub': 'Client Hub',
  'nav.menu': 'Menu',
  'nav.home': 'Home',
  'nav.products': 'Products',
  'nav.liveCasino': 'Live Casino',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Table Games',
  'nav.library': 'Library',
  'nav.roadmap': 'Roadmap',
  'nav.assets': 'Assets',
  'nav.guidelines': 'Guidelines',
  'nav.account': 'Account',
  'nav.signOut': 'Sign out',
  'nav.categoriesAria': 'Game categories',
  'nav.sectionsAria': 'Main sections',
  'nav.brandAria': 'RichyPlay Client Hub',
  'nav.comingSoon': 'Coming soon',
  'nav.soon': 'Soon',

  'lang.label': 'Language',
  'lang.select': 'Select language',

  'category.live': 'Live',
  'category.slot': 'Slot',
  'category.instant': 'Instant',
  'category.table': 'Table',

  'status.planned': 'Planned',
  'status.in_progress': 'In progress',
  'status.shipped': 'Shipped',
  'status.available': 'Available',
  'status.coming_soon': 'Coming soon',
  'status.maintenance': 'Maintenance',

  'common.error': 'Something went wrong',
  'common.checkingSession': 'Checking session…',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.none': 'None',
  'common.active': 'Active',
  'common.inactive': 'Inactive',

  'home.eyebrow': 'Operator portal',
  'home.title': 'Client Hub',
  'home.lead':
    'Explore the RichyPlay portfolio — launch demos, track the roadmap, and download brand assets from one cinematic workspace.',
  'home.enterLibrary': 'Enter library',
  'home.viewRoadmap': 'View roadmap',
  'home.browse': 'Browse by category',
  'home.openLibrary': 'Open library',

  'library.eyebrow': 'Game library',
  'library.title': 'Portfolio',
  'library.liveTitle': 'Live Casino Portfolio',
  'library.slotTitle': 'Slot Portfolio',
  'library.liveLead': 'Choose a live product. Royal Blackjack and Royal Roulette are live; the rest is coming soon.',
  'library.lead': 'Search and filter the RichyPlay catalog. Launch demos in a new tab.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.search': 'Search games…',
  'library.statusFilterAria': 'Filter by status',
  'library.statusAll': 'All statuses',
  'library.loading': 'Loading games…',
  'library.unavailableTitle': 'Library unavailable',
  'library.unavailableMessage': 'Could not load the game library. The catalog may be unavailable.',
  'library.apiFailedMessage':
    'We could not reach the catalog API. Try again later or contact support.',
  'library.emptyTitle': 'No games found',
  'library.emptyMessage': 'Try a different search or category filter.',
  'library.viewGame': 'View game',

  'game.loading': 'Loading game…',
  'game.notFound': 'Game not found.',
  'game.back': 'Back',
  'game.breadcrumbAria': 'Breadcrumb',
  'game.liveCasino': 'Live Casino',
  'game.slots': 'Slots',
  'game.demoFrameTitle': '{title} demo',
  'game.startingDemo': 'Starting demo session…',
  'game.demoNotStarted': 'Demo session could not be started.',
  'game.demoBadge': 'Demo mode',
  'game.blockedMaintenance': 'This game is in maintenance.',
  'game.blockedComingSoon': 'Coming soon — demo not published yet.',
  'game.blockedNoDemo': 'The operator catalog does not expose a demo build for this title.',
  'game.currency': 'Currency',
  'game.language': 'Language',
  'game.reloadDemo': 'Reload demo',
  'game.startDemo': 'Start demo',
  'game.openNewTab': 'Open in new tab',
  'game.copyLink': 'Copy link',
  'game.copied': 'Copied',
  'game.demoFailedTitle': 'Demo launch failed',
  'game.demoUrlMissing': 'Launch URL was not returned by the server.',
  'game.demoFailed': 'Failed to launch the demo.',
  'game.highlighted': 'Highlighted',
  'game.features': 'Game features',
  'game.keyFeatures': 'Key Features',
  'liveTable.title': 'Available Tables',
  'liveTable.totalResults': 'Total Results:',
  'liveTable.download': 'Download Table Data',
  'liveTable.gameId': 'Game ID',
  'liveTable.tableName': 'Table Name',
  'liveTable.minLimit': 'Min Table Limit',
  'liveTable.maxLimit': 'Max Table Limit',
  'liveTable.hours': 'Operating Hours UTC',
  'liveTable.language': 'Operating Language',
  'liveTable.releaseDate': 'Release Date',
  'liveTable.location': 'Location',
  'game.betLevels': 'Bet levels',
  'game.tableRules': 'Table rules',
  'game.mathConfig': 'Math configuration',
  'game.resources': 'Resources',
  'game.relatedAssets': 'Related assets',
  'game.releaseRoadmap': 'Release roadmap',
  'game.integrationGuidelines': 'Integration guidelines',
  'game.information': 'Game information',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Desktop',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Mobile',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'The game data sheet will be added soon.',

  'spec.releaseDate': 'Release Date',
  'spec.symbol': 'Game Symbol',
  'spec.numericId': 'Numeric ID',
  'spec.minBetPerLine': 'Minimum Bet Per Line',
  'spec.minTotalBet': 'Minimum Total Bet',
  'spec.maxTotalBet': 'Maximum Total Bet',
  'spec.maxTotalBetAnte': 'Maximum Total Bet with Ante',
  'spec.reels': 'Reels',
  'spec.rows': 'Rows',
  'spec.payType': 'Pay Type',
  'spec.payLinesValue': '{count} lines',
  'spec.symbolPays': 'Symbol Pays',
  'spec.betMultiplier': 'Bet Multiplier',
  'spec.maxMultiplierWin': 'Max Multiplier Win',
  'spec.maxExposure': 'Max Exposure',
  'spec.bonusBuyX': 'Bonus Buy X',
  'spec.anteBetX': 'Ante Bet X',
  'spec.rtps': 'RTPs',
  'spec.hitFrequency': 'Hit Frequency',
  'spec.oneIn': '1 in {value}',
  'spec.hasReplay': 'Has Replay',
  'spec.hasBuySpins': 'Has Buy Spins',
  'spec.hasInstantBonus': 'Has Instant Bonus',
  'spec.hasHyperplay': 'Has Hyperplay',
  'spec.hasAnteBet': 'Has Ante Bet',
  'spec.referenceId': 'Reference ID',
  'spec.provider': 'Provider',
  'spec.product': 'Product',
  'spec.gameType': 'Game type',
  'spec.category': 'Category',
  'spec.theme': 'Theme',
  'spec.technology': 'Technology',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatility',
  'spec.maxWin': 'Max win',
  'spec.paylines': 'Pay lines',
  'spec.grid': 'Grid',
  'spec.bonusFrequency': 'Bonus frequency',
  'spec.bonusFrequencyValue': '1 in {value}',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Bet range',
  'spec.defaultBet': 'Default bet',
  'spec.currency': 'Currency',
  'spec.languages': 'Languages',
  'spec.demoAvailable': 'Demo available',
  'spec.tournaments': 'Tournaments',
  'spec.highlighted': 'Highlighted',
  'spec.status': 'Status',
  'spec.version': 'Version',
  'spec.lastUpdated': 'Last updated',

  'roadmap.eyebrow': 'Product roadmap',
  'roadmap.title': 'What’s next',
  'roadmap.lead': 'Track upcoming releases and shipped titles by category.',
  'roadmap.bannerAria': 'Upcoming releases',
  'roadmap.soonTitle': 'Coming soon',
  'roadmap.loading': 'Loading roadmap…',
  'roadmap.error': 'Could not load roadmap items.',
  'roadmap.emptyTitle': 'No roadmap items',
  'roadmap.emptyMessage': 'There are no published roadmap entries for this category yet.',
  'roadmap.itemCount': '{count} items',
  'roadmap.target': 'Target: {date}',
  'roadmap.viewInLibrary': 'View in library',

  'upcoming.title': 'Upcoming Releases',
  'upcoming.playDemo': 'Play demo',
  'upcoming.prev': 'Previous releases',
  'upcoming.next': 'Next releases',

  'assets.eyebrow': 'Brand assets',
  'assets.title': 'Asset packs',
  'assets.lead':
    'Download logos, key art, and marketing materials. See {link} for usage rules.',
  'assets.leadLink': 'asset guidelines',
  'assets.loading': 'Loading assets…',
  'assets.error': 'Could not load asset packs.',
  'assets.downloadFailed': 'Download failed.',
  'assets.emptyTitle': 'No assets yet',
  'assets.emptyForGame': 'No asset packs are linked to this game.',
  'assets.emptyGeneral': 'Asset packs will appear here when published.',
  'assets.pack': 'Pack',
  'assets.updated': 'Updated {date}',
  'assets.download': 'Download',
  'assets.search': 'Search by game name…',
  'assets.searchEmpty': 'No games match that name.',

  'guidelines.eyebrow': 'Documentation',
  'guidelines.title': 'Guidelines',
  'guidelines.lead': 'Integration notes, asset usage, and operator references.',
  'guidelines.all': 'All',
  'guidelines.integration': 'Integration',
  'guidelines.assets': 'Assets',
  'guidelines.loading': 'Loading guidelines…',
  'guidelines.error': 'Could not load guidelines.',
  'guidelines.emptyTitle': 'No guidelines',
  'guidelines.emptyMessage': 'Published guidelines will appear here.',
  'guidelines.index': 'Index',
  'guidelines.navAria': 'Guidelines navigation',
  'guidelines.articleLoading': 'Loading article…',
  'guidelines.notFound': 'Guideline not found.',
  'guidelines.notFoundShort': 'Not found',
  'guidelines.updated': 'Updated {date}',
  'guidelines.external': 'Content is hosted externally.',
  'guidelines.openDocument': 'Open document',
  'guidelines.typeGuide': 'Guide',
  'guidelines.typeGuideline': 'Guideline',

  'account.eyebrow': 'Your account',
  'account.title': 'Profile',
  'account.email': 'Email',
  'account.language': 'Interface language',
  'account.recentActivity': 'Recent activity',
  'account.loadingActivity': 'Loading activity…',
  'account.activityUnavailable': 'Recent activity is not available right now.',
  'account.noActivity': 'No recent activity recorded.',

  'event.login': 'Signed in',
  'event.logout': 'Signed out',
  'event.libraryView': 'Viewed library',
  'event.gameView': 'Viewed game',
  'event.demoLaunch': 'Launched demo',
  'event.demoLaunchFailed': 'Demo launch failed',
  'event.assetDownload': 'Downloaded asset',
  'event.guidelineView': 'Viewed guideline',
  'event.roadmapView': 'Viewed roadmap',

  'auth.title': 'Client Hub',
  'auth.subtitle': 'Sign in with your operator credentials',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.rememberMe': 'Remember me',
  'auth.signIn': 'Sign in',
  'auth.signInFailed': 'Sign in failed',
  'auth.signInError': 'Unable to sign in. Check your credentials and try again.',
  'auth.forgotPassword': 'Forgot password?',
  'auth.inviteOnly': 'Invite-only access. Contact your RichyPlay representative.',
  'auth.visitSiteAria': 'Go to richyplay.live',

  'footer.navAria': 'Footer',
  'footer.tagline': 'Operator portal for the RichyPlay slots and live casino catalogue.',
  'footer.rights': 'All rights reserved.',
  'footer.legal': 'Invite-only access for licensed operators. For business use only.',

  'forgot.eyebrow': 'Password reset',
  'forgot.title': 'Forgot password',
  'forgot.requestSubtitle':
    'Enter your email and we’ll send a verification code if an account exists.',
  'forgot.sendCode': 'Send code',
  'forgot.sendError': 'Unable to send reset code.',
  'forgot.confirmSubtitle': 'Enter the code from your email and choose a new password.',
  'forgot.code': 'Verification code',
  'forgot.newPassword': 'New password',
  'forgot.update': 'Update password',
  'forgot.updateError': 'Unable to reset password.',
  'forgot.doneSubtitle': 'Your password has been updated. You can sign in now.',
  'forgot.backToSignIn': 'Back to sign in',
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
